import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { catalogBibShape, bibShape } from '@bibliocommons/bc-prop-types';
import Divider from 'app/components/bibs/shared/Divider';

import { MoreFromNoveList } from 'app/components/bibs/shared/MoreFromProvider';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import { CONTENT_PROVIDER_IDS } from 'app/constants/BibConstants';
import { getRecommendationProviderDisplayName } from 'app/helpers/bib/bibHelpers';

import './AllRecommendationsPage.scss';

export function AllRecommendationsPage({ catalogBib, recommendations, handleAuthorClick }) {
  function renderRecommendation(recommendation, index) {
    const metadataId = recommendation.get('id');
    const providerName = recommendation.get('providerName');
    const nextProviderName = recommendations.getIn([index + 1, 'providerName']);

    return (
      <div className="recommendation" key={metadataId}>
        <BibBriefContainer
          metadataId={metadataId}
          size="large"
          showAdditionalInfo={false}
          showRating
          showAuthorAsLink
          showJacketAsLink
          showTitleAsLink
          showDescription
          source={providerName}
          sourceComponent="AllRecommendationsPage"
          handleAuthorClick={handleAuthorClick}
        />
        {/* Render provider name of the last recommendation by the current provider */}
        {providerName !== nextProviderName && (
          <>
            <div className="provider-info">
              <span className="provider-name">
                <FormattedMessage
                  id="recommendations_provided_by"
                  values={{
                    provider: getRecommendationProviderDisplayName(providerName)
                  }}
                />
              </span>
              {providerName?.toUpperCase() === CONTENT_PROVIDER_IDS.NOVELIST && (
                <MoreFromNoveList className="more-from-novelist" metadataId={metadataId} showHeading={false} />
              )}
            </div>
            {index !== recommendations.size - 1 && <Divider />}
          </>
        )}
      </div>
    );
  }

  function renderRecommendations() {
    return recommendations && recommendations.size ? (
      recommendations.map(renderRecommendation)
    ) : (
      <div className="no-content-placeholder">
        <FormattedMessage id="no_recommendations" />
      </div>
    );
  }

  return (
    <div className="cp-all-recommendations-page">
      <BibSubPage
        catalogBib={catalogBib}
        headerLocKey="recommendations_may_also_like"
        sourceComponent="AllRecommendationsPage"
      >
        <Divider />
        {renderRecommendations()}
      </BibSubPage>
    </div>
  );
}

AllRecommendationsPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  recommendations: ImmutablePropTypes.listOf(bibShape).isRequired,
  handleAuthorClick: PropTypes.func.isRequired
};

export default AllRecommendationsPage;
